import {
  DEFAULT_DATA_CENTER_THEME_ID,
  resolveDataCenterTheme,
} from '../config/dataCenterThemes.mjs';

const STORAGE_PREFIX = 'webford-data-center-theme:';

function browserStorage() {
  try {
    return globalThis.localStorage || null;
  } catch {
    return null;
  }
}

export function getDataCenterThemeStorageKey(username) {
  const normalizedUsername = String(username || '').trim() || 'anonymous';
  return `${STORAGE_PREFIX}${encodeURIComponent(normalizedUsername)}`;
}

export function readDataCenterThemeId(username, storage = browserStorage()) {
  if (!storage) return DEFAULT_DATA_CENTER_THEME_ID;

  try {
    return resolveDataCenterTheme(storage.getItem(getDataCenterThemeStorageKey(username))).id;
  } catch {
    return DEFAULT_DATA_CENTER_THEME_ID;
  }
}

export function writeDataCenterThemeId(username, themeId, storage = browserStorage()) {
  if (!storage) return false;

  const resolved = resolveDataCenterTheme(themeId);
  if (resolved.id !== themeId) return false;

  try {
    storage.setItem(getDataCenterThemeStorageKey(username), resolved.id);
    return true;
  } catch {
    return false;
  }
}
